import React from 'react';

import ListaPacientesPainel from './ListaPacientes';

const Painel: React.FC = () => {
  return (
    <>
      <ListaPacientesPainel />
    </>
  );
};

export default Painel;
